import { useState, useEffect } from 'react';
import { translations } from '../utils/language';

const useLanguage = () => {
  const [language, setLanguage] = useState('pt');

  useEffect(() => {
    // Carregar idioma inicial do localStorage
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'pt';
    setLanguage(savedLanguage);

    // Escutar mudanças no localStorage (entre abas)
    const handleStorageChange = (e) => {
      if (e.key === 'selectedLanguage') {
        setLanguage(e.newValue || 'pt');
      }
    };

    // Escutar mudanças customizadas (na mesma aba)
    const handleLanguageChange = (e) => {
      setLanguage(e.detail.language);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('languageChanged', handleLanguageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  // Função para traduzir textos
  const t = (key) => {
    return translations[key]?.[language] || translations[key]?.['pt'] || key;
  };

  // Função para mudar idioma programaticamente
  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('selectedLanguage', newLanguage);
    
    // Disparar evento para notificar outros componentes
    window.dispatchEvent(new CustomEvent('languageChanged', {
      detail: { language: newLanguage }
    }));
  };

  return { 
    language, 
    t, 
    changeLanguage 
  };
};

export default useLanguage;